import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import Home from './Home';
import Payment from './Payment';
import Success from './Success';
import Cancel from './Cancel';
import DarkToggle from './DarkToggle';
import Login from './Login';
import Register from './Register';
import Timetable from './Timetable';
import { AuthProvider, useAuth } from './AuthContext';
import './App.css';

function NavBar() {
  const { user } = useAuth();
  return (
    <nav className="top-nav">
      <Link to="/" className="logo-link">Student Resource Hub</Link>
      <div className="nav-actions">
        <Link to="/timetable" className="nav-link">Timetable</Link>
        {user ? (
          <span className="nav-user">{user.email}</span>
        ) : (
          <Link to="/login" className="nav-link">Log in</Link>
        )}
        <DarkToggle />
      </div>
    </nav>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/timetable" element={<Timetable />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;